
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.911 8.712h-.294V6.108A6.114 6.114 0 007.509 0a6.114 6.114 0 00-6.107 6.108c0 .31.248.559.559.559.31 0 .559-.249.559-.56a4.995 4.995 0 014.99-4.989 4.995 4.995 0 014.989 4.99v2.604H1.112c-.596 0-1.08.485-1.08 1.081v6.96a3.243 3.243 0 003.237 3.239h8.485a3.243 3.243 0 003.238-3.238V9.793c0-.596-.485-1.08-1.081-1.08zm-.037 8.042c0 1.167-.949 2.12-2.12 2.12h-8.48a2.122 2.122 0 01-2.12-2.12V9.83h12.72v6.924z"}}),_c('path',{attrs:{"d":"M7.513 16.526c1.156 0 2.092-.94 2.092-2.091 0-1.155-.94-2.091-2.092-2.091-1.155 0-2.09.94-2.09 2.09 0 1.152.935 2.092 2.09 2.092zm0-3.068a.975.975 0 010 1.95.975.975 0 010-1.95z"}})])
          )
        }
      }
    